module.exports = "/_next/static/images/Hero@2x-6c07948b2fdc59c0774a9aacea67b8e1.webp";